var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuantumicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_158_1696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.48126 15.2132H3.91641C2.66941 15.2132 1.65702 14.2007 1.65702 12.9538C1.65702 12.0187 2.41632 11.2593 3.35155 11.2593H2.78673C1.53974 11.2593 0.527344 10.2468 0.527344 8.99993C0.527344 7.75304 1.53974 6.74054 2.78673 6.74054H3.35159C2.41636 6.74054 1.65705 5.98109 1.65705 5.04601C1.65705 3.79912 2.66945 2.78662 3.91644 2.78662H4.4813",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.61091 3.91641C4.98742 3.91641 4.48124 3.4103 4.48124 2.78673C4.48124 1.53984 5.49363 0.527344 6.74059 0.527344C7.98754 0.527344 8.99997 1.53984 8.99997 2.78673V15.2133C8.99997 16.4602 7.98758 17.4727 6.74059 17.4727C5.4936 17.4727 4.4812 16.4602 4.4812 15.2133C4.4812 14.5897 4.98738 14.0836 5.61088 14.0836",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 6.17578C9.00002 6.95527 8.36728 7.5879 7.5879 7.5879C6.80852 7.5879 6.17578 6.95527 6.17578 6.17578M9.00002 11.8242C9.00002 11.0447 8.36728 10.4121 7.5879 10.4121C6.80852 10.4121 6.17578 11.0447 6.17578 11.8242",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5188 16.3428C14.1427 16.3428 14.6485 15.8371 14.6485 15.2132C14.6485 14.5893 14.1427 14.0835 13.5188 14.0835C12.8949 14.0835 12.3892 14.5893 12.3892 15.2132C12.3892 15.8371 12.8949 16.3428 13.5188 16.3428Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5188 3.91633C14.1427 3.91633 14.6485 3.41056 14.6485 2.78666C14.6485 2.16276 14.1427 1.65698 13.5188 1.65698C12.8949 1.65698 12.3892 2.16276 12.3892 2.78666C12.3892 3.41056 12.8949 3.91633 13.5188 3.91633Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3431 7.87019C16.967 7.87019 17.4727 7.36442 17.4727 6.74052C17.4727 6.11661 16.967 5.61084 16.3431 5.61084C15.7192 5.61084 15.2134 6.11661 15.2134 6.74052C15.2134 7.36442 15.7192 7.87019 16.3431 7.87019Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3431 12.389C16.967 12.389 17.4727 11.8832 17.4727 11.2593C17.4727 10.6354 16.967 10.1296 16.3431 10.1296C15.7192 10.1296 15.2134 10.6354 15.2134 11.2593C15.2134 11.8832 15.7192 12.389 16.3431 12.389Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7201 14.4146L11.2594 12.954H9M12.7201 3.58545L11.2594 5.04612H9M9 7.87036H12.3891L13.5187 6.74065H15.2133M9 10.1297H12.3891L13.5187 11.2594H15.2133",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_158_1696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantumicon);
export default __webpack_public_path__ + "static/media/quantumicon.734997c2424e20f86494be8cf22f8a83.svg";
export { ForwardRef as ReactComponent };